import React from 'react'
import Background from './../background.webp'

const Landscape = () => {
    return (
        <>
            <img onContextMenu={(e)=>e.preventDefault()} draggable="false" alt='' src={Background} className='background-image' />
        </>
    )
}

export default Landscape